var rereqInfoUrl = 'https://www.invitae.com/en/re-requisition/';
var testPageUrl = 'https://www.invitae.com/en/physician/tests/';
var specimenRequirements = 'https://www.invitae.com/en/specimen-requirements/';

export { rereqInfoUrl, specimenRequirements, testPageUrl };
//# sourceMappingURL=urls.esm.js.map
